import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';

import Spinner from '@/images/Spinner.png';
import SpinnerWhite from '@/images/SpinnerWhite.png';

const rotate = keyframes`
from {
  transform: rotate(0deg);
}

to {
  transform: rotate(360deg);
}
`;

const Img = styled.img`
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    animation: ${rotate} 2s linear infinite;
`;

interface Props {
    style?: Record<string, any>;
    color?: 'white' | 'black';
    className?: string;
}

export default function ({ style, color = 'black', className }: Props) {
    return <Img src={color === 'white' ? SpinnerWhite : Spinner} className={className} alt="Loading" style={style} />;
}
